import { 
  createStore, 
  combineReducers,
  applyMiddleware
} from 'redux'

import { thunk } from 'redux-thunk'
import appReducer from './appReducer'
import { reducer as formReducer } from 'redux-form'

const reduxDevTools = process.env.NODE_ENV === 'development' ? (
  window.__REDUX_DEVTOOLS_EXTENSION__ && 
  window.__REDUX_DEVTOOLS_EXTENSION__()
) : undefined

const store = createStore( 
  combineReducers({
    form: formReducer,
    app: appReducer,
  }), 
  /*applyMiddleware(thunk)*/
 // reduxDevTools
)

export default store 



// WEBPACK FOOTER //
// ./src/store.js